<template>
    <div class="row">
         <base-modal v-if="items"
                @is-destroy="setDestroy"
                :index="this.index"
            >
            <div slot='description' v-for="(item,index) in items" :key="index">
                
                <div class="input-field col s12">
                    <label
                        class="active"
                        :for="item.nome"
                    >
                        {{item.nome}}
                    </label>
                    <textarea 
                        class="materialize-textarea"
                        :id="item.nome"
                        :value="item.conteudo"
                        disabled
                    >
                    </textarea>
                    
                </div>
                <div class="col s12">
                    <datalist :id="`datalist${index}`" 
                        v-if="item.notas_validas && item.notas_validas.length"
                        
                        >
                            <option 
                                v-for="(nota,j) in item.notas_validas" 
                                :key="j"
                                :value="nota"
                                
                                >
                            </option>
                        </datalist>
                    <label 
                        class="active"
                        :for="`input${index}`" 
                        >
                        Nota do(a) {{item.nome}}
                    </label>
                    <div class="input-field inline">
                        <input 
                            :id="`input${index}`"
                            :list="`datalist${index}`"
                            v-model="item.nota"
                            @change="dataListOnChange(index, item.nota)"
                            />
                        
                    </div>
                </div>
            </div>
            
            <span 
                class="green-text text-darken-2"
                slot='footer'
                id="nota-total-span"
            >Nota:{{notaTotal}}
            </span>

            
        </base-modal>
    </div>
</template>
<script>
const ITEMS_URL = '/api/items/reports';
import { mapState } from 'vuex';
import BaseModal from './BaseModal.vue';
export default {
    name: 'AvaliacaoRelatorioModal',
    props:{
        bolsista: Object,
        index: Number
        
    },
    components:{
        BaseModal
    },
    computed:{
        ...mapState(['project'])
    },
    data(){
        return {
            notaTotal : this.bolsista.notaTotal,
            conteudoIndex: 3,
            items: []
        }
    },
    methods:{
        setDestroy(){
           this.$destroy();
        },
        dataListOnChange(index, nota){
            let {notas_validas} = this.items[index];
            let isValid = this.verifyNota(notas_validas,nota);
            if(!isValid){
                showMsg(`Nota ${nota} é Inváida`);
                this.items[index].nota = 0;
            }
            this.sum();
        },
        sum(){
            let aux = this.items
            .map(e=>e.nota)
            .reduce((currentValue, acc) =>{
                return  Number(currentValue) + Number(acc)
            })
			
            this.notaTotal = aux.toFixed(2);
            this.$emit('get-nota-total',{items:this.items,notaTotal:this.notaTotal});
        },
        verifyNota(notas_validas,nota){
            return notas_validas.includes(nota);
        },
        async getItems(){
               try {
                let {data} = await this.$http.get(ITEMS_URL);
                data.map((e,i)=>{
                    e.nota = null;
                    e.notas_validas = [];
                    let j = 0 ;
                    let items = JSON.parse(this.bolsista.campos);
                    e.conteudo =  items[i+1][3] == "" ? "SEM CONTEÚDO" :items[i+1][3];
                    for(let i = Number(e.nota_min); i.toFixed(2) <= Number(e.nota_max);i = i + Number(e.nota_var)){
                        e.notas_validas[j] = i.toFixed(2);
                        j++;
                        
                    }

                    
                });
                return data;
            } catch (error) {
                console.error(error);
            }
        }
        
    },
    beforeDestroy(){
        this.$emit('get-nota-total',{items:this.items,notaTotal:this.notaTotal});
    },
    async created(){
        if(this.bolsista.items && this.bolsista.items.length){
            this.$set(this,'items',this.bolsista.items);    
        }
            
        else{
            this.$set(this,'items',await this.getItems());
        }
            
        
    }
    
    
    
}
</script>
<style scoped>
    #nota-total-span{
        font-size: 20px;
    }
    label{
        font-size: 18px !important;
    }
</style>